module.exports = __webpack_public_path__ + "static/media/2.74b6ef4c.jpg";